const translations = {
  'developingTeacher.seo.title': '12-Month TEFL Course in Barcelona, Spain, with Student Visa',
  'developingTeacher.seo.description': `Deepen your knowledge and hone your skills with our 12-month advanced teaching course. Courses suitable for long-term student visas in Spain. `,
  'developingTeacher.sec1.title': 'Developing Teacher Course',
  'developingTeacher.sec1.description':
    'Hone your skills as a teacher with advanced teaching workshops.',
  'developingTeacher.sec1.weeks': '6-12 months',
  'developingTeacher.sec1.hours': '20 hours per week of study',
  'developingTeacher.sec1.cities': 'Barcelona',

  'developingTeacher.sec2.title': 'Take Your Teaching To The Next Level',
  'developingTeacher.sec2.description':
    ' The Developing Teacher course is an advanced TEFL course aimed at those who already have some TEFL training / work experience and want to deepen their subject knowledge and brush up on their skills.',
  'developingTeacher.sec2.benefitsTitle': 'This course is ideal for you if:',
  'developingTeacher.sec2.benefit1':
    'You have completed the Trinity CertTESOL course (or a similar 160-hour TEFL course).',
  'developingTeacher.sec2.benefit2':
    'You are from the US, Canada, Australia, (or any other non-EU country) and want to qualify for a student visa.',
  'developingTeacher.sec2.benefit3':
    'You want to deepen your teaching knowledge and improve your skills.',
  'developingTeacher.sec2.key': 'Key Information:',
  'developingTeacher.sec2.key1.title': '6-12 months',
  'developingTeacher.sec2.key1.text': 'Course duration',
  'developingTeacher.sec2.key2.title': 'Flexible',
  'developingTeacher.sec2.key2.text': 'Start date',
  'developingTeacher.sec2.key3.title': '12',
  'developingTeacher.sec2.key3.text': 'Max of students per group',
  'developingTeacher.sec2.ben1.title': 'Networking And Peer Support',
  'developingTeacher.sec2.ben1.text':
    'You’ll be plugged into a large network of teachers in Barcelona, to support and learn from each other.',
  'developingTeacher.sec2.ben2.title': 'Qualify For A Student Visa',
  'developingTeacher.sec2.ben2.text':
    'Our course meets the requirements to apply for a long-term student visa.',
  'developingTeacher.sec2.ben3.title': 'Study At Your Own Pace',
  'developingTeacher.sec2.ben3.text':
    'Attend core workshops every week and manage the rest of your studies to suit your timetable.',
  'developingTeacher.sec2.ben4.title': 'Small Group Sizes',
  'developingTeacher.sec2.ben4.text':
    'Our classes max out at 12, giving everybody access to an instructor.',

  'developingTeacher.sec3.title': 'What’s Included?',
  'developingTeacher.sec3.benefit1':
    '20 hours per week of course work (3 hours in-school sessions per week).',
  'developingTeacher.sec3.benefit2': 'Expert tuition from professional teachers.',
  'developingTeacher.sec3.benefit3': 'All the paperwork necessary to process your student visa.',
  'developingTeacher.sec3.benefit4':
    'Access to our beautiful school library, high-speed wifi, computers.',
  'developingTeacher.sec3.benefit5':
    'Job contacts and placement help – our host school hires exclusively from TEFL Iberia graduates.',
  'developingTeacher.sec3.benefit6': 'Access to our network of Barcelona teachers.',
  'developingTeacher.sec3.fullPrice': 'FULL PRICE:',
  'developingTeacher.sec3.discountPrice': 'DISCOUNT PRICE:',
  'developingTeacher.sec3.payInFull': 'When you sign up to 1 year of classes ',
  'developingTeacher.sec3.oneYear': 'for 1 year',
  'developingTeacher.sec3.quotation':
    'The staff is amazing with teachers who really care about your future. The course is challenging, but prepares you for the world of teaching English as a second language. They assist you throughout the course with things such as accommodation, finding a job, and visa requirements. I would recommend this school to anyone who wants to become certified or just have an incredible journey in Barcelona.',
  'developingTeacher.sec8.title': 'Plan de estudios y horario del curso',
  'developingTeacher.sec8.description':
    '   The Developing Teacher course is a combination of practical workshops and self study. The workshops take place at the school on <accent>Fridays, 12.30-14.00.</accent>',
  'developingTeacher.sec8.notification.title': '¿El inglés no es tu lengua materna?',
  'developingTeacher.sec8.notification.description':
    'Debes demostrar un nivel C1 para poder realizar el curso.',
  'btn.takeEnglisAssessment': 'English level test',
  'developingTeacher.btn.downloadTrinitySyllabus':
    'Download the Trinity CertTESOL syllabus',
  'btn.viewMoreFaqs': 'view more faqs',
  'common.faqs': 'Frequently asked questions',
  'developingTeacher.sec11.title': 'Otros <accent>cursos populares</accent>',
  'developingTeacher.sec11.description': 'Lleva tu formación al siguiente nivel con TEFL Iberia',
  'developingTeacher.sec11.course1': 'Trinity CertTESOL Course',
  'developingTeacher.sec11.course2': 'Teaching Young Learners',
  'developingTeacher.sec11.course3': 'Intensive Spanish Course',
  'developingTeacher.sec11.month': 'month',
  'developingTeacher.sec11.days': '3 day course',
};

export default translations;
